// MotoEbikes — premium background shader + organic intro loader
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- intro loader ---------- */
  var loader = document.getElementById('loader');
  function hideLoader() {
    if (!loader) return;
    loader.classList.add('hide');
    setTimeout(function () { loader.style.display = 'none'; }, 800);
  }
  if (reduce) {
    hideLoader();
  } else {
    var start = Date.now();
    window.addEventListener('load', function () {
      setTimeout(hideLoader, Math.max(0, 900 - (Date.now() - start)));
    });
    setTimeout(hideLoader, 4200); // safety net
  }

  /* ---------- living background shader ---------- */
  var cv = document.getElementById('bgfx');
  if (!cv) return;
  var gl = cv.getContext('webgl', { antialias: false, alpha: false, depth: false })
        || cv.getContext('experimental-webgl');
  if (!gl) return; // graceful fallback: dark base + smoked panels remain

  var vs = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.0,1.0);}';
  var fs = [
    'precision highp float;',
    'uniform vec2 u_res; uniform float u_time;',
    'float hash(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
    'float noise(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.0-2.0*f);',
    ' float a=hash(i),b=hash(i+vec2(1.0,0.0)),c=hash(i+vec2(0.0,1.0)),d=hash(i+vec2(1.0,1.0));',
    ' return mix(mix(a,b,u.x),mix(c,d,u.x),u.y);}',
    'float fbm(vec2 p){float v=0.0,a=0.5;mat2 m=mat2(1.6,1.2,-1.2,1.6);',
    ' for(int i=0;i<6;i++){v+=a*noise(p);p=m*p;a*=0.5;}return v;}',
    'void main(){',
    ' vec2 uv=gl_FragCoord.xy/u_res.xy;',
    ' vec2 p=(gl_FragCoord.xy-0.5*u_res.xy)/u_res.y;',
    ' float t=u_time*0.04;',
    ' vec2 q=vec2(fbm(p*1.5+vec2(0.0,t)),fbm(p*1.5+vec2(5.2,t*1.3)));',
    ' vec2 r=vec2(fbm(p*1.5+4.0*q+vec2(1.7,t*0.8)),fbm(p*1.5+4.0*q+vec2(8.3,t*0.6)));',
    ' float f=fbm(p*1.8+3.0*r+t*0.4);',
    ' vec3 c0=vec3(0.015,0.035,0.028);',
    ' vec3 c1=vec3(0.02,0.17,0.10);',
    ' vec3 c2=vec3(0.04,0.75,0.45);',
    ' vec3 col=mix(c0,c1,smoothstep(0.18,0.72,f));',
    ' col=mix(col,c2,smoothstep(0.62,0.96,f)*0.55*r.x);',
    ' float vig=smoothstep(1.25,0.15,length(p));',
    ' col*=mix(0.5,1.0,vig);',
    ' col+=0.018*hash(uv+t);',
    ' gl_FragColor=vec4(col,1.0);',
    '}'
  ].join('\n');

  function compile(type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src); gl.compileShader(s);
    return s;
  }
  var prog = gl.createProgram();
  gl.attachShader(prog, compile(gl.VERTEX_SHADER, vs));
  gl.attachShader(prog, compile(gl.FRAGMENT_SHADER, fs));
  gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
  gl.useProgram(prog);

  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, 'p');
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

  var uRes = gl.getUniformLocation(prog, 'u_res');
  var uTime = gl.getUniformLocation(prog, 'u_time');

  function resize() {
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5) * 0.7;
    cv.width = Math.max(1, Math.floor(window.innerWidth * dpr));
    cv.height = Math.max(1, Math.floor(window.innerHeight * dpr));
    gl.viewport(0, 0, cv.width, cv.height);
    gl.uniform2f(uRes, cv.width, cv.height);
  }
  window.addEventListener('resize', resize);
  resize();

  var t0 = performance.now(), raf;
  function frame(now) {
    gl.uniform1f(uTime, (now - t0) / 1000);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
    raf = requestAnimationFrame(frame);
  }
  if (reduce) {
    gl.uniform1f(uTime, 9.0);
    gl.drawArrays(gl.TRIANGLES, 0, 3); // single static frame
  } else {
    raf = requestAnimationFrame(frame);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { cancelAnimationFrame(raf); }
      else { t0 = performance.now(); raf = requestAnimationFrame(frame); }
    });
  }
})();
